import React, { useState } from 'react';
import { TextInput, Button, Notification, rem } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';
import api from '../../services/api';
import API_URL from '../../config';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(null);

    try {
      // Appel API pour envoyer le lien de réinitialisation de mot de passe
      await api.post(`${API_URL}/users/forgot-password/`, { email });
      setSuccess(true);
    } catch (error) {
      console.error('Erreur de réinitialisation de mot de passe:', error);
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: 'auto', padding: rem(20) }}>
      <h2>Réinitialiser votre mot de passe</h2>
      <form onSubmit={handleForgotPassword}>
        <TextInput
          label="Adresse e-mail"
          placeholder="Entrez votre adresse e-mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <Button type="submit" fullWidth mt="md" loading={loading}>
          Envoyer le lien de réinitialisation
        </Button>
      </form>

      {success === true && (
        <Notification icon={<IconCheck size={rem(20)} />} color="teal" title="Succès !" mt="md">
          Un lien de réinitialisation a été envoyé à votre adresse e-mail.
        </Notification>
      )}
      {success === false && (
        <Notification icon={<IconX size={rem(20)} />} color="red" title="Erreur !" mt="md">
          Impossible d’envoyer le lien de réinitialisation. Vérifiez l'adresse e-mail et réessayez.
        </Notification>
      )}
    </div>
  );
};

export default ForgotPasswordPage;